<!-- Divider -->
<div
    class="red-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper!"></div>
